import { createContext, useContext, useReducer } from 'react';

const UserContext = createContext();
const UserDispatchContext = createContext();

export const UserTypes = {
  SET_PROFILE: 'SET_PROFILE',
  CLEAR_PROFILE: 'CLEAR_PROFILE',
  UPDATE_PROFILE: 'UPDATE_PROFILE'
};

const initialState = {
  profile: null,
  accessToken: null,
  isLogin: false,
  userLoading: true,
  error: null
};

function userReducer(state, action) {
  switch (action.type) {
    case UserTypes.SET_PROFILE:
      console.log(`set profile in context:`, action.payload.profile);
      localStorage.setItem("userID", action.payload.profile.id);
      localStorage.setItem("username", action.payload.profile.username);
      return {
        ...state,
        profile: action.payload.profile,
        accessToken: action.payload.accessToken,
        isLogin: true,
        userLoading: false,
        error: null
      };
    case UserTypes.CLEAR_PROFILE:
      console.log("clear profile in context",initialState);
      return {
        ...initialState,
        userLoading: false
      };
    case UserTypes.UPDATE_PROFILE:
      return {
        ...state,
        profile: { ...state.profile, ...action.payload }
      };
    default:
      return state;
  }
}

export function UserProvider({ children }) {
  const [state, dispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}

export function useUserDispatch() {
  return useContext(UserDispatchContext);
} 